import React, { Component } from 'react';

import { s3CacheUrl } from '../Common/util';

export class CasertaQuote extends Component {
  render() {
    return(
      <div className={"collabs-banner-quote caserta-fg tile is-5"}>
        {`“As the work evolves, color, material and substrate become more important: I tend to go from concept to structure to finished materials.”`}
        <div className={"collabs-banner-byline"}>
          —John Caserta
        </div>
      </div>
    );
  }
}

export class CasertaBio extends Component {
  render() {
    return(
      <div className={"collabs-bio"}>
        <div className={"collabs-divider caserta-bg"} />

        <div className={"collabs-section white tile is-ancestor"}>
          <div className={'collabs-bio-image-container tile is-5'}>
            <img className={"collabs-bio-image"} alt={"John Caserta"} src={s3CacheUrl("https://s3.amazonaws.com/weft-public-assets/images/weft-shop-collab/caserta/caserta1weft-artist-portrait-388x350.jpg", 350)} />
          </div>
          <div className={"collabs-bio-header tile is-5"}>
            <h1>Code as a Medium</h1>
            <p>The manipulation and exploration of computer code drives the graphic design work of John Caserta.</p>
          </div>
        </div>

        <div className={"collabs-section grey"}>
          <div className={"bio-content"}>
            <p>Working primarily in programming web languages, artist and graphic designer Caserta uses computer code to create a 
            wide-ranging array of projects. He remarks, “I think of code as a set of instructions. The instructions don’t have to 
            be complex or rigid to be effective. I use code to arrive at unexpected solutions — not to execute upon statically 
            generated mockups.” Indeed, it’s often through the creative and playful exploration of code that Caserta’s projects 
            usually take formation. He explains, “HTML/CSS and Javascript are easy to manipulate, but lead to such unexpected outcomes. 
            The key is to be open to what they produce… Noodling around in the code is what leads to novel structures, hierarchies and forms.”</p>
   
            <p>For his collaboration with Weft, Caserta used Chrome’s Web Inspector, manipulating and experimenting with code to create a 
            graphic pattern. Reflecting on the design, he notes, “It’s an overlapping box-diamond structure that seemed really simple at 
            first, but I found that quite a lot of complexity came across. For example, there’s this sense that you could lose the repeat 
            and lose yourself in a section of it.” He summarizes, “And once you start applying color, there are a lot combinations that 
            can come through and make it unique.”</p>
          </div>
        </div>
      </div>
    );
  }
}